"use client";

import {
  cornerFirouz,
  cornerYellow,
  kangoro1,
  kangoro2,
  paternFirouz,
  paternYellow,
  samour1,
  samour2,
  samandkan,
} from "@/assets/bebras";
import baseImages from "@/assets/images";
import flash from "@/assets/hello/flash.png";
import taghvim from "@/assets/hello/dete_icon.png";
import tic from "@/assets/hello/tic.png";
import Image from "next/image";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  FormEvent,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import dynamic from "next/dynamic";
import {
  GraduationCap,
  Earth,
  BadgeCheck,
  Calendar1,
  CircleCheck,
  X,
  ArrowLeft,
  User,
  Phone,
  MapPin,
  Building2,
  ChevronDown,
} from "lucide-react";
import FaqSection from "./faq";
import FormModal from "./SignupFormModal";
import { useUser } from "@/context/UserContext";
import AuthStepController from "@/components/auth/AuthStepController";
import { submitTeacherTrainingRegistration } from "@/actions/submitTeacherTrainingRegistration";
import { sendVerificationSms } from "@/actions/sendVerificationSms";
import { Cities, Ostan } from "../learn-hoosh/data";

const VideoContent = dynamic(() => import("./VideoContent"), {
  ssr: false,
});

const maskPhone = (p?: string) =>
  p && p.length >= 7 ? `${p.slice(0, 4)}***${p.slice(-2)}` : "—";

const adlandLog = (
  level: "info" | "warn" | "error",
  step: string,
  payload?: unknown
) => {
  const time = new Date().toISOString();
  console[level](`[ADLAND][${time}][${step}]`, payload ?? "");
};

const expireDate = new Date("2026-10-07T00:00:00");
const isExpired = new Date() >= expireDate;

type WebinarFormData = {
  firstName: string;
  lastName: string;
  phone: string;
  grade: string;
  province: string;
  city: string;
};

const WEBINAR_GRADES = [
  "اول - ابتدایی",
  "دوم - ابتدایی",
  "سوم - ابتدایی",
  "چهارم - ابتدایی",
  "پنجم - ابتدایی",
  "ششم - ابتدایی",
  "هفتم - متوسطه اول",
  "هشتم - متوسطه اول",
  "نهم - متوسطه اول",
  "دهم - متوسطه دوم",
  "یازدهم - متوسطه دوم",
  "دوازدهم - متوسطه دوم",
];

const fieldBase =
  "h-14 w-full rounded-xl border border-slate-200 bg-white pr-12 pl-4 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 hover:border-blue-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60";

function SuccessModal({
  open,
  onClose,
  title = "ثبت‌نام شما با موفقیت انجام شد!",
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
}) {
  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    const previousPosition = document.body.style.position;
    const previousWidth = document.body.style.width;
    const previousTop = document.body.style.top;
    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.overflow = "hidden";

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.position = previousPosition;
      document.body.style.width = previousWidth;
      document.body.style.top = previousTop;
      document.body.style.overflow = previousOverflow;
      window.scrollTo(0, scrollY);
      window.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  const close = () => {
    onClose();
    window.location.hash = "";
  };

  return (
    <div
      className="fixed inset-0 z-[110] flex items-end justify-center bg-slate-950/60 p-0 backdrop-blur-sm sm:items-center sm:p-5"
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-modal-title"
        dir="rtl"
        onClick={(event) => event.stopPropagation()}
        className="relative w-full max-w-md overflow-hidden rounded-t-[28px] bg-white p-6 shadow-2xl sm:rounded-[28px] sm:p-8"
      >
        <button
          type="button"
          onClick={close}
          className="absolute left-4 top-4 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200 focus:outline-none focus:ring-4 focus:ring-slate-200"
          aria-label="بستن"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex flex-col items-center text-center">
          <Image src={tic} alt="tic" />
          <h2
            id="success-modal-title"
            className="text-lg font-black text-green-700 sm:text-xl"
          >
            {title}
          </h2>

          <hr className="border w-full my-4 border-[#E6E7ED]" />

          <p className="mt-2 max-w-xs text-sm leading-7 text-slate-500 sm:text-[15px]">
            لینک ورود به کلاس و اطلاعات بیشتر برای شما از طریق{" "}
            <span className="text-[#2D29BB]">پیامک</span> ارسال خواهد شد .
          </p>

          <button
            type="button"
            onClick={close}
            className="mt-7 flex h-12 w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[#2D29BB] px-8 text-sm text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-violet-600/25 focus:outline-none focus:ring-4 focus:ring-violet-200"
          >
            <CircleCheck className="h-5 w-5" />
            متوجه شدم
          </button>
        </div>
      </div>
    </div>
  );
}

function WebinarField({
  label,
  icon,
  withChevron,
  children,
}: {
  label: string;
  icon: ReactNode;
  withChevron?: boolean;
  children: ReactNode;
}) {
  return (
    <label className="block min-w-0">
      <span className="mb-2 block text-sm font-bold text-slate-800">
        {label}
      </span>
      <div className="relative">
        <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-slate-500">
          {icon}
        </span>
        {children}
        {withChevron && (
          <ChevronDown className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        )}
      </div>
    </label>
  );
}

function WebinarFormModal({
  open,
  onClose,
  defaultValues,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  defaultValues: Pick<WebinarFormData, "firstName" | "lastName" | "phone">;
  onSubmit: (
    data: WebinarFormData
  ) => Promise<{ success: boolean; message?: string }>;
}) {
  const [form, setForm] = useState({
    ...defaultValues,
    grade: "",
    provinceId: "",
    city: "",
  });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setForm({ ...defaultValues, grade: "", provinceId: "", city: "" });
      setError("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    const previousPosition = document.body.style.position;
    const previousWidth = document.body.style.width;
    const previousTop = document.body.style.top;
    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.overflow = "hidden";

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.position = previousPosition;
      document.body.style.width = previousWidth;
      document.body.style.top = previousTop;
      document.body.style.overflow = previousOverflow;
      window.scrollTo(0, scrollY);
      window.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  const filteredCities = useMemo(
    () => Cities.filter((c) => String(c.provinceId) === form.provinceId),
    [form.provinceId]
  );

  if (!open) return null;

  const set = <K extends keyof typeof form>(key: K, value: (typeof form)[K]) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");

    const firstName = form.firstName.trim();
    const lastName = form.lastName.trim();
    const phone = form.phone.trim();

    if (!firstName || !lastName) {
      setError("نام و نام خانوادگی را وارد کنید.");
      return;
    }
    if (!/^09\d{9}$/.test(phone)) {
      setError("شماره موبایل باید ۱۱ رقم و با ۰۹ شروع شود.");
      return;
    }
    if (!form.grade || !form.provinceId || !form.city) {
      setError("پایه تحصیلی، استان و شهر را انتخاب کنید.");
      return;
    }

    const provinceLabel =
      Ostan.find((p) => String(p.value) === form.provinceId)?.label ?? "";

    setIsSubmitting(true);
    try {
      const result = await onSubmit({
        firstName,
        lastName,
        phone,
        grade: form.grade,
        province: provinceLabel,
        city: form.city,
      });
      if (!result.success) {
        setError(
          result.message || "خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید."
        );
      }
    } catch {
      setError("خطا در ثبت اطلاعات. لطفاً دوباره تلاش کنید.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end justify-center bg-slate-950/60 p-0 backdrop-blur-sm sm:items-center sm:p-5"
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="webinar-modal-title"
        dir="rtl"
        className="relative max-h-[96dvh] w-full max-w-2xl overflow-y-auto rounded-t-[28px] bg-white px-5 pb-6 pt-5 shadow-2xl sm:rounded-[28px] sm:px-10 sm:pb-8"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute left-5 top-5 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-slate-700 transition hover:bg-slate-100"
          aria-label="بستن"
        >
          <X className="h-6 w-6" />
        </button>

        {/* هدر */}
        <div className="flex flex-col items-center text-center">
          <div className="flex h-36 w-36 items-center justify-center rounded-full bg-gradient-to-b from-indigo-50 to-white sm:h-40 sm:w-40">
            <Image
              src={taghvim}
              alt="webinar"
              className="h-28 w-auto sm:h-32"
            />
          </div>

          <h2
            id="webinar-modal-title"
            className="mt-3 text-3xl font-black text-slate-900 sm:text-4xl"
          >
            وبینار رایگان
          </h2>
          <p className="mt-2 text-2xl font-black text-indigo-600 sm:text-3xl">
            هوش ریاضیات کانگورو
          </p>
          <p className="mt-4 text-lg font-bold text-slate-900 sm:text-xl">
            استاد رنجبری
          </p>
          <p className="mt-1 text-sm text-slate-700 sm:text-base">
            دوشنبه ۲۰ مهرماه - ساعت ۱۷
          </p>

          <div className="mt-5 flex w-full items-center gap-3">
            <div className="h-px flex-1 bg-blue-200" />
            <span className="text-blue-600">✦</span>
            <div className="h-px flex-1 bg-blue-200" />
          </div>
        </div>

        {/* فرم */}
        <form onSubmit={handleSubmit} className="mt-6">
          <div className="grid grid-cols-1 gap-x-5 gap-y-5 sm:grid-cols-2">
            <WebinarField label="نام" icon={<User className="h-5 w-5" />}>
              <input
                type="text"
                value={form.firstName}
                onChange={(e) => set("firstName", e.target.value)}
                className={fieldBase}
                placeholder="نام خود را وارد کنید"
                autoComplete="given-name"
              />
            </WebinarField>

            <WebinarField
              label="نام خانوادگی"
              icon={<User className="h-5 w-5" />}
            >
              <input
                type="text"
                value={form.lastName}
                onChange={(e) => set("lastName", e.target.value)}
                className={fieldBase}
                placeholder="نام خانوادگی خود را وارد کنید"
                autoComplete="family-name"
              />
            </WebinarField>

            <WebinarField label="تلفن" icon={<Phone className="h-5 w-5" />}>
              <input
                type="text"
                inputMode="numeric"
                maxLength={11}
                value={form.phone}
                onChange={(e) =>
                  set("phone", e.target.value.replace(/\D/g, "").slice(0, 11))
                }
                className={fieldBase}
                placeholder="مثال: 09123456789"
                autoComplete="off"
              />
            </WebinarField>

            <WebinarField
              label="پایه تحصیلی"
              icon={<GraduationCap className="h-5 w-5" />}
              withChevron
            >
              <select
                value={form.grade}
                onChange={(e) => set("grade", e.target.value)}
                className={`${fieldBase} appearance-none pl-10 ${
                  form.grade ? "" : "text-slate-400"
                }`}
              >
                <option value="">پایه تحصیلی را انتخاب کنید</option>
                {WEBINAR_GRADES.map((g) => (
                  <option key={g} value={g} className="text-slate-800">
                    {g}
                  </option>
                ))}
              </select>
            </WebinarField>

            <WebinarField
              label="استان"
              icon={<MapPin className="h-5 w-5" />}
              withChevron
            >
              <select
                value={form.provinceId}
                onChange={(e) => {
                  set("provinceId", e.target.value);
                  set("city", "");
                }}
                className={`${fieldBase} appearance-none pl-10 ${
                  form.provinceId ? "" : "text-slate-400"
                }`}
              >
                <option value="">استان را انتخاب کنید</option>
                {Ostan.map((p) => (
                  <option
                    key={p.value}
                    value={String(p.value)}
                    className="text-slate-800"
                  >
                    {p.label}
                  </option>
                ))}
              </select>
            </WebinarField>

            <WebinarField
              label="شهر"
              icon={<Building2 className="h-5 w-5" />}
              withChevron
            >
              <select
                value={form.city}
                onChange={(e) => set("city", e.target.value)}
                disabled={!form.provinceId}
                className={`${fieldBase} appearance-none pl-10 ${
                  form.city ? "" : "text-slate-400"
                }`}
              >
                <option value="">
                  {form.provinceId
                    ? "شهر را انتخاب کنید"
                    : "ابتدا استان را انتخاب کنید"}
                </option>
                {filteredCities.map((c) => (
                  <option
                    key={`${c.provinceId}-${c.label}`}
                    value={c.label}
                    className="text-slate-800"
                  >
                    {c.label}
                  </option>
                ))}
              </select>
            </WebinarField>
          </div>

          {error && (
            <div
              role="alert"
              className="mt-5 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-bold text-rose-700"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="mt-6 flex h-14 w-full cursor-pointer items-center justify-center gap-3 rounded-xl bg-[#0B3BE8] text-lg font-black text-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-blue-600/25 focus:outline-none focus:ring-4 focus:ring-blue-200 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
          >
            {isSubmitting ? (
              <>
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                در حال ثبت...
              </>
            ) : (
              <>
                <Calendar1 className="h-6 w-6" />
                ثبت‌نام در وبینار
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

function StickyRegistrationBar({
  isLoggedIn,
  onOpenConference,
}: {
  isLoggedIn: boolean;
  onOpenConference: () => void;
  onOpenSignup: () => void;
}) {
  const conferenceButtonClass =
    "group cursor-pointer flex min-h-16 w-full items-center justify-between rounded-2xl border border-white/20 bg-gradient-to-l from-[#157212] via-green-600 to-green-800 px-3 py-2 text-white transition duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-violet-200 sm:min-h-[76px] sm:px-4";

  const arrow = (colorClass: string) => (
    <span
      className={`flex h-11 w-11 items-center justify-center rounded-full bg-white ${colorClass} shadow-lg transition duration-300 group-hover:-translate-x-1 sm:h-13 sm:w-13`}
    >
      <ArrowLeft className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={2.4} />
    </span>
  );

  const conferenceContent = (
    <>
      <span className="w-12 sm:w-16" />
      <span className="text-2xl font-black sm:text-3xl">
        ثبت‌نام وبینار رایگان
      </span>
      {arrow("text-[#127728]")}
    </>
  );

  return (
    <div dir="rtl" className="flex sm:flex-row flex-col gap-2">
      {!isExpired &&
        (isLoggedIn ? (
          <button
            type="button"
            onClick={onOpenConference}
            className={conferenceButtonClass}
          >
            {conferenceContent}
          </button>
        ) : (
          <AuthStepController
            id="teacher-training-course"
            triggerButton={
              <button
                type="button"
                onClick={() => (window.location.hash = "conference-modal")}
                className={conferenceButtonClass}
              >
                {conferenceContent}
              </button>
            }
          />
        ))}
    </div>
  );
}

export const BebrasPageContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [webinarFormOpen, setWebinarFormOpen] = useState(false);
  const [registrationOpenConference, setRegistrationOpenConference] =
    useState(false);
  const { isLoggedIn, user: profile } = useUser();
  const hasOpenedConference = useRef(false);

  const webinarKey = `sms-sent_${profile?.phoneNumber}`;

  const handleOpenConferenceModal = useCallback(() => {
    if (localStorage.getItem(webinarKey) === "true") {
      setRegistrationOpenConference(true);
      return;
    }
    setWebinarFormOpen(true);
  }, [webinarKey]);

  const handleWebinarSubmit = useCallback(
  async (data: WebinarFormData) => {
    const requestType = "وبینار کانگورو";
    const startedAt = performance.now();

    adlandLog("info", "1-START", {
      requestType,
      phone: maskPhone(data.phone),
      grade: data.grade,
      province: data.province,
      city: data.city,
      online: typeof navigator !== "undefined" ? navigator.onLine : "unknown",
    });

    let adlandResult:
      | Awaited<ReturnType<typeof submitTeacherTrainingRegistration>>
      | undefined;

    try {
      adlandLog("info", "2-REQUEST-SENT");

      adlandResult = await submitTeacherTrainingRegistration({
        requestType,
        fullName: `${data.firstName} ${data.lastName}`.trim(),
        phone: data.phone,
        email: "",
        data: {
          grade: data.grade,
          province: data.province,
          city: data.city,
        },
      });
    } catch (error) {
      adlandLog("error", "3-EXCEPTION", {
        durationMs: Math.round(performance.now() - startedAt),
        name: error instanceof Error ? error.name : typeof error,
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        online: navigator.onLine,
      });
      return {
        success: false,
        message: "ارتباط با سرور برقرار نشد. لطفاً دوباره تلاش کنید.",
      };
    }

    const durationMs = Math.round(performance.now() - startedAt);

    if (!adlandResult || typeof adlandResult.success !== "boolean") {
      adlandLog("error", "3-INVALID-RESPONSE", {
        durationMs,
        raw: adlandResult,
      });
      return {
        success: false,
        message: "پاسخ نامعتبر از سرور دریافت شد.",
      };
    }

    if (!adlandResult.success) {
      adlandLog("warn", "3-REJECTED", {
        durationMs,
        message: adlandResult.message,
        raw: adlandResult,
      });
      return { success: false, message: adlandResult.message };
    }

    adlandLog("info", "3-SUCCESS", { durationMs, raw: adlandResult });

    try {
      adlandLog("info", "4-SMS-SENT", { phone: maskPhone(data.phone) });

      const smsResult = await sendVerificationSms({
        mobile: data.phone,
        templateId: 231184,
        parameters: [
          { name: "LINK", value: "wk" },
          { name: "NAME", value: `${data.phone} ` },
        ],
      });

      if (!smsResult?.success) {
        adlandLog("error", "5-SMS-FAILED-AFTER-ADLAND-OK", {
          message: smsResult?.message,
          raw: smsResult,
        });
        return { success: false, message: smsResult?.message };
      }

      adlandLog("info", "5-SMS-SUCCESS", { raw: smsResult });
    } catch (error) {
      adlandLog("error", "5-SMS-EXCEPTION-AFTER-ADLAND-OK", {
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
      });
      return {
        success: false,
        message: "ارسال پیامک با خطا مواجه شد.",
      };
    }

    localStorage.setItem(webinarKey, "true");
    adlandLog("info", "6-DONE", {
      totalMs: Math.round(performance.now() - startedAt),
      storageKey: webinarKey,
    });

    setWebinarFormOpen(false);
    setRegistrationOpenConference(true);
    return { success: true };
  },
  [webinarKey]
);

  useEffect(() => {
    if (
      isLoggedIn &&
      profile?.phoneNumber &&
      window.location.hash === "#conference-modal" &&
      !hasOpenedConference.current
    ) {
      hasOpenedConference.current = true;
      handleOpenConferenceModal();
    }
  }, [isLoggedIn, profile?.phoneNumber, handleOpenConferenceModal]);

  return (
    <div className="w-480 max-w-[100vw] mx-auto pb-24">
      <FormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/** هدر دسکتاپ */}
      <div className="w-full h-auto hidden md:visible md:flex place-self-center ">
        <div className="flex-row flex">
          <div className="w-3/4 h-full object-cover ml-20">
            <Image
              className="items-center"
              width={600}
              alt="samandkan"
              src={samandkan}
            />
          </div>
          <div className="flex-col flex mr-40 items-end mt-20">
            <h1 className="font-colak lg:text-[67px] md:text-[64px] text-right text-blue-900 leading-none mb-5">
              آزمــون‌های بین‌المللی
              <br />
              <span className="text-yellow-400 text-right"> کانگـــــورو </span>
              &nbsp;و&nbsp;
              <span className="text-teal-500 text-right"> بــبــراس </span>
            </h1>
            <p className="lg:text-[21px] md:text-[18px] text-right font-pinar">
              مسیر موفقیت در ریاضیات، تفکر رایانشی و حل مسئله
            </p>
            <p
              className="lg:text-[16px] md:text-[14px] text-right mt-1 font-pinar"
              style={{ direction: "rtl" }}
            >
              با شرکت در این آزمون‌های معتبر جهانی، مهارت‌های تفکر منطقی، خلاقیت
              و حل مسئله را تقویت کنید و آینده‌ای روشن بسازید.
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-[#FFB81F] rounded-2xl text-[20px] hover:bg-yellow-700 transition-color duration-300 cursor-pointer px-12.5 py-3 text-teal-700 mt-5"
            >
              ثبت‌نام
              <GraduationCap size={30} className="inline-flex ml-2.5" />
            </button>
          </div>
        </div>
      </div>

      {/** هدر موبایل */}
      <div className="w-full h-auto md:hidden visible block ">
        <div className="block">
          <div className="w-full h-full object-cover mt-2.5">
            <Image className="items-center" alt="samandkan" src={samandkan} />
          </div>
          <div className="w-full grid grid-cols-1 items-center mt-10">
            <h1 className="font-colak text-[50px] text-center text-blue-900 leading-20 mb-2.5">
              آزمــون‌های بین‌المللی
              <br />
              <span className="text-yellow-400"> کانگـــــورو </span>
              &nbsp;و&nbsp;
              <span className="text-teal-500"> بــبــراس </span>
            </h1>
            <p className="text-[21px] text-center font-pinar mt-2.5 px-5">
              مسیر موفقیت در ریاضیات، تفکر رایانشی و حل مسئله
            </p>
            <p
              className="text-[18px] text-center mt-2 font-pinar px-5"
              style={{ direction: "rtl" }}
            >
              با شرکت در این آزمون‌های معتبر جهانی، مهارت‌های تفکر منطقی، خلاقیت
              و حل مسئله را تقویت کنید و آینده‌ای روشن بسازید.
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-yellow-500 rounded-2xl mx-5 text-[20px] active:bg-yellow-700 active:text-teal-400 transition-color duration-300 cursor-pointer px-12.5 py-3 text-teal-700 mt-5"
            >
              ثبت نام <GraduationCap size={30} className="inline-flex ml-2.5" />
            </button>
          </div>
        </div>
      </div>

      {/** کارت ثبت‌نام رایگان وبینار */}
      {!isExpired && (
        <section dir="rtl" className="mx-auto mb-16 px-4">
          <div className="bg-[#F6F7FE] py-5 px-10 max-w-230 mx-auto rounded-2xl shadow-xl">
            <div className="flex gap-12 justify-center">
              <div className="space-y-4">
                <h2 className="text-[#2C42C8] font-bold text-center text-2xl">
                  ثبت‌نام رایگان در وبینار هوش ریاضیات کانگورو
                </h2>
                <div className="flex relative">
                  <p className="text-[#504f55] text-center">
                    جلسه اول دوره با استاد رنجبری در تاریخ دوشنبه ۲۰ مهرماه
                    ساعت ۱۷ برگزار میشود.
                  </p>
                  <Image
                    className="w-10 h-10 absolute -left-8 top-5 lg:block hidden"
                    src={flash}
                    alt="flash"
                  />
                </div>

                {isLoggedIn ? (
                  <button
                    onClick={handleOpenConferenceModal}
                    className="flex cursor-pointer mx-auto gap-2 bg-[#2B52E6] p-3 w-72 justify-center text-white rounded-2xl items-center transition-all duration-300 ease-out hover:scale-105 hover:shadow-[0_8px_25px_rgba(43,82,230,0.35)] active:scale-95"
                  >
                    <Calendar1 />
                    ثبت‌نام وبینار رایگان
                  </button>
                ) : (
                  <AuthStepController
                    id="teacher-training-course"
                    triggerButton={
                      <button
                        onClick={() =>
                          (window.location.hash = "conference-modal")
                        }
                        className="flex cursor-pointer mx-auto gap-2 bg-[#2B52E6] p-3 w-72 justify-center text-white rounded-2xl items-center transition-all duration-300 ease-out hover:scale-105 hover:shadow-[0_8px_25px_rgba(43,82,230,0.35)] active:scale-95"
                      >
                        <Calendar1 />
                        ثبت‌نام وبینار رایگان
                      </button>
                    }
                  />
                )}
              </div>

              <div className="lg:block hidden">
                <Image className="w-40 h-36" src={taghvim} alt="taghvim" />
              </div>
            </div>
          </div>
        </section>
      )}

      {/** خرگوش مطالعه گر دسکتاپ */}
      <div className="w-full h-170 mt-8 relative md:block md:visible hidden">
        <div className="h-150 w-full flex items-center absolute mt-15">
          <div className="h-3/4 w-full justify-items-start relative">
            {/** تصویر پترنی */}
            <Image
              className="w-1/2 h-full object-cover absolute"
              width={1000}
              alt="morabaA"
              src={paternYellow}
            />
            {/** تصویر کانگورو */}
            <div className="w-2/5 mr-20 h-full object-cover absolute justify-self-end">
              <div className="w-full h-full flex items-center justify-self-start">
                <Image
                  width={600}
                  alt="kangoro"
                  className="w-full h-auto object-contain"
                  src={kangoro1}
                />
              </div>
            </div>
            <div className="w-1/2 h-full object-cover absolute">
              <div className="w-9/10 h-full flex flex-col items-end justify-center pl-2">
                <div className="font-pinar text-[16px] text-right font-bold opacity-75 border border-amber-900 bg-amber-400 rounded-4xl px-2.5 py-2 flex items-center">
                  آزمون بین‌المللی
                  <Earth className="ml-2" size={20} />
                </div>
                <div className="font-colak lg:text-[82px] md:text-[55px] text-right">
                  <h1>ریاضیات کانگورو</h1>
                </div>
                <p
                  className="w-5/6 text-[20px] text-justify font-pinar"
                  style={{ direction: "rtl" }}
                >
                  مسابقه‌ای بین‌المللی در ریاضیات برای دانش‌آموزان با هدف تقویت
                  تفکر منطقی، خلاقیت و توان حل مسئله. سؤال ها به گونه‌ای طراحی
                  شده‌اند که مناسب گروه سنی مختلف و در سطوح گوناگون هستند.
                </p>
                <div className="mt-2.5 flex gap-2">
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    رقابت بین‌المللی
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    دانش‌آموزی
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    حل‌مسئله
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    ریاضی
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/** دو تا کرنر */}
        <div className="absolute h-full w-full justify-self-center flex justify-between flex-row">
          <div className="w-1/5 h-full place-content-start ml-10">
            <Image
              alt="corner"
              width={310}
              className="aspect-620/610 w-full rotate-270"
              src={cornerYellow}
            />
          </div>
          <div className="w-1/5 h-full place-content-end mr-10">
            <Image
              alt="corner"
              width={310}
              className="aspect-620/610 w-full rotate-90"
              src={cornerYellow}
            />
          </div>
        </div>
      </div>

      {/** خرگوش مطالعه گر موبایل */}
      <div className="w-full mt-8 relative md:hidden visible block">
        <Image
          width={600}
          alt="kangoro"
          className="w-full h-auto pt-16"
          src={kangoro1}
        />

        <div className="w-full h-100 justify-items-end relative">
          <Image
            className="w-full absolute h-full pb-16"
            alt="morabaA"
            src={paternYellow}
          />
          <div className="w-full h-full flex flex-col items-end gap-2 absolute p-6 pb-16">
            <div className="font-pinar text-[18px] text-right font-bold opacity-75 border border-amber-900 bg-amber-400 rounded-4xl px-2.5 py-2 flex items-center">
              آزمون بین‌المللی
              <Earth className="ml-2" size={20} />
            </div>
            <h1 className="font-colak text-[62px] text-right">
              ریاضیات کانگورو
            </h1>
            <p className="text-[17px] w-8/9 text-right ">
              مسابقه‌ای بین‌المللی در ریاضیات برای دانش‌آموزان با هدف تقویت تفکر
              منطقی، خلاقیت و توان حل مسئله. سؤال ها به گونه‌ای طراحی شده‌اند که
              مناسب گروه سنی مختلف و در سطوح گوناگون هستند.
            </p>
          </div>
        </div>

        <Image
          alt="corner"
          width={310}
          className="w-1/2 top-0 right-4 absolute"
          src={cornerYellow}
        />

        <Image
          alt="corner"
          width={310}
          className="w-1/2 absolute left-4 bottom-0 rotate-180"
          src={cornerYellow}
        />
      </div>

      {/** خرگوش دارتی دسکتاپ */}
      <div className="w-full h-120 mt-8 relative content-center flex-row items-center hidden md:visible md:flex">
        <div className="flex-2 place-items-center">
          <Image
            src={kangoro2}
            width={520}
            className="h-full object-cover"
            alt="kangoro2"
          />
        </div>
        <div className="h-90 flex-3 relative">
          <div className="absolute w-full h-full flex flex-col text-right truncate place-items-center">
            <h2 className="font-colak text-[42px] flex-1 place-content-center">
              اهداف و مأموریت رویداد ریاضیات کانگورو
            </h2>
            <div
              className="text-[22px] flex flex-col flex-2 justify-evenly mr-2 mb-10"
              style={{ direction: "rtl" }}
            >
              <li>کمک به درک کاربرد ریاضیات در زندگی روزمره</li>
              <li>افزایش اعتمادبه‌نفس و مهارت حل مسئله در ریاضی</li>
              <li>ترویج فعالیت‌های ریاضی میان دانش‌آموزان و معلمان</li>
              <li>تقویت توانمندی و لذت از فعالیت‌های هوشمندانه ریاضی</li>
              <li>ایجاد فضایی شاد برای علاقه‌مند شدن به ریاضیات</li>
            </div>
          </div>
          <Image
            src={paternYellow}
            width={1000}
            className="h-full w-full object-cover"
            alt="patter"
          />
        </div>
      </div>

      {/** خرگوش دارتی موبایل */}
      <div className="w-full mt-8 relative md:hidden visible block">
        <Image
          alt="corner"
          width={310}
          className="w-1/2 top-0 left-4 absolute -rotate-90 z-20"
          src={cornerYellow}
        />

        <Image
          alt="corner"
          width={310}
          className="w-1/2 absolute right-4 bottom-0 rotate-90 z-20"
          src={cornerYellow}
        />

        <Image
          width={600}
          alt="kangoro"
          className="w-full h-auto pt-16"
          src={kangoro2}
        />

        <div className="w-full h-fit justify-items-end relative z-10">
          <Image
            className="w-full h-full pb-16 z-10 absolute"
            width={1000}
            alt="morabaA"
            src={paternYellow}
          />
          <div className="w-full h-full flex flex-col items-end gap-4 p-6 pb-16 z-50 relative">
            <h2 className="font-colak text-[42px] text-right mb-4">
              اهداف و مأموریت رویداد ریاضیات کانگورو
            </h2>
            <div className="text-[18px] flex flex-col font-pinar flex-2 gap-4 pb-4 justify-evenly mr-17.5">
              <li style={{ direction: "rtl" }}>
                <div>کمک به درک کاربرد ریاضیات در زندگی روزمره</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>افزایش اعتمادبه‌نفس و مهارت حل مسئله در ریاضی</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>ترویج فعالیت‌های ریاضی میان دانش‌آموزان و معلمان</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>تقویت توانمندی و لذت از فعالیت‌های هوشمندانه ریاضی</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>ایجاد فضایی شاد برای علاقه‌مند شدن به ریاضیات</div>
              </li>
            </div>
          </div>
        </div>
      </div>

      {/** سمور فیروزه ای مداد به دست دسکتاپ */}
      <div className="w-full h-170 mt-8 relative hidden md:visible md:block">
        <div className="h-150 w-full flex items-center absolute mt-15">
          <div className="h-3/4 w-full justify-items-start relative">
            <div className="w-1/2 h-full object-cover absolute justify-self-end">
              <div className="w-full h-full flex items-center justify-center">
                <Image
                  width={600}
                  alt="samour"
                  className="h-[120%] w-auto object-contain rotate-y-180"
                  src={samour1}
                />
              </div>
            </div>
            <Image
              className="w-3/5 h-full object-cover absolute"
              width={1000}
              alt="morabaA"
              src={paternFirouz}
            />
            <div className="w-3/5 h-full object-cover absolute">
              <div className="w-full h-full flex flex-col items-end justify-center gap-3 pr-10">
                <div className="font-pinar text-[16px] text-right font-bold border border-teal-900 bg-white/30 rounded-4xl px-2.5 py-2 flex items-center">
                  چالش بین‌المللی
                  <Earth className="ml-2" size={20} />
                </div>
                <h2 className="font-colak md:text-[46px] lg:text-[68px] text-right">
                  علوم رایانه و تفکر رایانشی ببراس
                </h2>
                <p
                  style={{ direction: "rtl" }}
                  className="w-6/7 text-[20px] text-right"
                >
                  ببراس چالشی جهانی در حوزه علوم رایانه و تفکر رایانشی است که با
                  هدف تقویت تفکر منطقی، استدلال الگوریتمی، تشخیص الگو و حل
                  خلاقانه مسئله در دانش آموزان برگزار می‌شود.{" "}
                </p>
                <div className="mt-2.5 flex gap-2">
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    حل‌مسئله
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    الگوریتم
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    علوم رایانه
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                  <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center">
                    تفکر محاسباتی
                    <BadgeCheck className="ml-2" size={20} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/** دو تا کرنر */}
        <div className="absolute h-full w-full justify-self-center flex justify-between flex-row">
          <div className="w-1/5 h-full place-content-end ml-10">
            <Image
              alt="corner"
              width={310}
              className="aspect-620/610 w-full rotate-90"
              src={cornerFirouz}
            />
          </div>
          <div className="w-1/5 h-full place-content-start mr-10">
            <Image
              alt="corner"
              width={310}
              className="aspect-620/610 w-full rotate-270"
              src={cornerFirouz}
            />
          </div>
        </div>
      </div>

      {/** سمور انگشتی موبایل */}
      <div className="w-full mt-8 relative md:hidden visible block">
        <Image
          width={600}
          alt="kangoro"
          className="w-3/5 h-auto pt-16 place-self-center"
          src={samour1}
        />

        <div className="w-full h-125 justify-items-end relative">
          <Image
            className="w-full absolute h-full pb-16"
            width={1000}
            alt="morabaA"
            src={paternFirouz}
          />
          <div className="w-full h-full flex flex-col items-end gap-2 absolute p-6 pb-16">
            <div className="font-pinar text-[16px] text-right font-bold border border-teal-900 bg-white/30 rounded-4xl px-2.5 py-2 flex items-center">
              چالش بین‌المللی
              <Earth className="ml-2" size={20} />
            </div>
            <h2 className="font-colak text-[35px] text-right">
              علوم رایانه و تفکر راینشی ببراس
            </h2>
            <p
              style={{ direction: "rtl" }}
              className="w-6/7 text-[18px] text-right"
            >
              ببراس چالشی جهانی در حوزه علوم رایانه و تفکر رایانشی است که با هدف
              تقویت تفکر منطقی، استدلال الگوریتمی، تشخیص الگو و حل خلاقانه مسئله
              در دانش آموزان برگزار می‌شود.{" "}
            </p>
            <div className="mt-2.5 grid grid-cols-2 gap-2">
              <div className="font-pinar text-[15px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center justify-center">
                حل‌مسئله
                <BadgeCheck className="ml-2" size={25} />
              </div>
              <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center justify-center">
                الگوریتم
                <BadgeCheck className="ml-2" size={25} />
              </div>
              <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center justify-center">
                علوم رایانه
                <BadgeCheck className="ml-2" size={25} />
              </div>
              <div className="font-pinar text-[16px] text-right font-bold border border-white bg-white/25 text-black/75 rounded-2xl px-2 py-2 flex items-center justify-center">
                تفکر محاسباتی
                <BadgeCheck className="ml-2" size={25} />
              </div>
            </div>
          </div>
        </div>

        <Image
          alt="corner"
          width={310}
          className="w-1/2 top-0 right-4 absolute -rotate-90"
          src={cornerFirouz}
        />

        <Image
          alt="corner"
          width={310}
          className="w-1/2 absolute left-4 bottom-0 rotate-90"
          src={cornerFirouz}
        />
      </div>

      {/** سمور اشاره کننده */}
      <div className="w-full h-120 relative content-center flex-row items-center hidden md:flex md:visible">
        <div className="flex-2 place-items-center">
          <Image
            src={samour2}
            width={480}
            className="h-full object-cover rotate-y-180"
            alt="samour2"
          />
        </div>
        <div className="h-90 flex-3 relative">
          <div className="absolute w-full h-full flex flex-col text-right truncate place-items-center">
            <h2 className="font-colak text-[42px] flex-1 place-content-center lg:-mr-20">
              اهداف چالش بین‌المللی علوم رایانه ببراس
            </h2>
            <div
              style={{ direction: "rtl" }}
              className="lg:text-[22px] flex flex-col flex-2 justify-evenly mb-10 md:text-[18px] "
            >
              <li>ترویج علوم رایانه و تفکر رایانشی در بین دانش‌آموزان</li>
              <li>تقویت مهارت‌های تفکر پیشرفته</li>
              <li>
                تشویق دانش‌آموزان به کاربرد مهارت‌های تفکر رایانشی در حل مسائل
              </li>
              <li>آماده‌سازی برای استفاده از فناوری اطلاعات در بزرگسالی</li>
            </div>
          </div>
          <Image
            src={paternFirouz}
            width={480}
            className="h-full w-full object-cover"
            alt="patter"
          />
        </div>
      </div>

      {/** سمور اشاره موبایل */}
      <div className="w-full mt-8 mb-5 relative md:hidden visible block">
        <Image
          alt="corner"
          width={310}
          className="w-1/2 top-0 left-4 absolute rotate-180 z-20"
          src={cornerFirouz}
        />

        <Image
          alt="corner"
          width={310}
          className="w-1/2 absolute right-4 bottom-0 z-20"
          src={cornerFirouz}
        />

        <Image
          width={600}
          alt="kangoro"
          className="w-4/5 justify-self-end mr-4 h-auto pt-16"
          src={samour2}
        />

        <div className="w-full h-fit justify-items-end relative z-10">
          <Image
            className="w-full h-full pb-16 z-10 absolute"
            width={1000}
            alt="morabaA"
            src={paternFirouz}
          />
          <div className="w-full h-full flex flex-col items-end gap-4 p-6 pb-16 z-50 relative">
            <h2 className="font-colak text-[44px] text-right mb-4">
              اهداف چالش بین‌المللی علوم رایانه ببراس
            </h2>
            <div className="text-[18px] flex flex-col font-pinar flex-2 gap-4 pb-4 justify-evenly mr-17.5">
              <li style={{ direction: "rtl" }}>
                <div>ترویج علوم رایانه و تفکر رایانشی در بین دانش‌آموزان</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>تقویت مهارت‌های تفکر پیشرفته</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>
                  تشویق دانش‌آموزان به کاربرد مهارت‌های تفکر رایانشی در حل مسائل
                </div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>تقویت توانمندی و لذت از فعالیت‌های هوشمندانه ریاضی</div>
              </li>
              <li style={{ direction: "rtl" }}>
                <div>آماده‌سازی برای استفاده از فناوری اطلاعات در بزرگسالی</div>
              </li>
            </div>
          </div>
        </div>
      </div>

      <div className="py-25 mx-5 md:mx-20 relative isolate overflow-hidden rounded-[20px] bg-[#FFB516] text-center">
        <div className="absolute md:top-45 top-85 left-1/2 aspect-square w-[140%] -translate-x-1/2 rounded-full bg-[#27BAA9]" />

        <div className="relative bottom-15">
          <h2 className="font-extrabold text-black font-colak sm:text-[50px] text-[35px] sm:px-0 px-5">
            وقتشه اهداف بین‌المللی خودت رو تیک بزنی
          </h2>
          <p className="text-black mt-5 md:mt-0 sm:text-[24px] text-[20px]">
            از طریق لینک زیر برای شرکت در آزمون یا کلاس اقدام کنید، در ادامه
            میتوانید شخصی سازی کنید
          </p>
        </div>

        <button
          onClick={() => setIsModalOpen(true)}
          className="absolute bottom-10 left-1/2 z-20 -translate-x-1/2 inline-flex items-center gap-2 rounded-2xl bg-[#FFB516] px-12.5 py-3 md:text-[18px] text-[24px] font-bold text-teal-800 cursor-pointer transition-color duration-300 hover:bg-[#7c5809]"
        >
          ثبت‌نام
          <GraduationCap />
        </button>
      </div>

      <div className="md:flex grid grid-cols-1 mb-75 md:mb-15 h-100 w-full justify-center my-15 gap-7.5">
        <div className="md:w-3/7 w-9/10 self-center-safe place-self-center">
          <video
            className="md:flex-1 h-full rounded-2xl"
            controls
            controlsList="nofullscreen nodownload noremoteplayback noplaybackrate foobar"
            disablePictureInPicture
            src="https://storage.set.ir/Forms/55.mp4"
          >
            {" "}
          </video>
        </div>
        <div
          style={{ direction: "rtl" }}
          className="md:w-3/7 w-9/10 place-self-center flex flex-col items-center bg-[#F8F9FB] rounded-2xl border border-LightGray"
        >
          <div className="mx-5 my-5">
            <h1 className="md:text-[24px] lg:text-[26px] font-pinar font-bold mb-5">
              کلاس های آمادگی آزمون کانگورو و ببراس
            </h1>
            <p className="mb-5 text-[16px] font-light text-[#323232] font-pinar leading-9">
              کلاس‌های آمادگی ما به دانش‌آموزان کمک می‌کند تا با شیوه‌های سؤالات
              آشنا شوند و مهارت‌های ریاضی و تفکر رایانشی خود را به بهترین شکل
              تقویت کنند.
            </p>
            <h1 className="md:text-[24px] lg:text-[26px] font-pinar font-bold my-5 mt-10">
              ویژگی های کلاس:
            </h1>
            <div className="list-none text-[16px] font-light text-[#323232] font-pinar flex flex-col gap-5">
              <li className="flex">
                <BadgeCheck className="ml-2.5" />
                عنوان کلاس: آمادگی آزمون کانگورو و ببراس
              </li>
              <li className="flex">
                <BadgeCheck className="ml-2.5" />
                نوع کلاس: جلسات آنلاین و ضبط شده
              </li>
              <li className="flex">
                <BadgeCheck className="ml-2.5" />
                استاد دوره: استاد رنجبری (مدرس برتر تیزهوشان)
              </li>
            </div>
          </div>
        </div>
      </div>

      {/** ویدئوها */}
      <VideoContent />

      <div className="w-full md:h-50 h-80 flex sm:flex-row flex-col justify-center mt-10 sm:gap-10 gap-5">
        <div className="md:w-3/7 w-9/10 h-40 shadow-xl rounded-2xl flex flex-row border justify-center items-center border-BrightGray place-self-center">
          <div className="content-center mx-5">
            <h1 className="sm:text-[20px] text-[15px] text-right font-bold mb-2.5">
              فیلم‌های آموزشی و تمرین
            </h1>
            <p className="sm:text-[16px] text-sm text-right">
              دسترسی به فیلم های آموزشی، جزوه‌ها و تمرین های تکمیلی
            </p>
          </div>
          <div className="relative bg-gray-100 rounded-2xl aspect-square mr-2.5 my-2.5 sm:w-32 w-20 h-20 sm:h-30">
            <Image
              fill
              alt="laptop with people"
              src={baseImages.deskwPlayBtn}
            />
          </div>
        </div>
        <div className="md:w-3/7 w-9/10 h-40 shadow-xl items-center rounded-2xl justify-center flex flex-row md:justify-end border border-BrightGray place-self-center">
          <div className="content-center mx-5">
            <h1 className="sm:text-[20px] txet-[15px] text-right font-bold mb-2.5">
              جلسات آنلاین زنده{" "}
            </h1>
            <p className="sm:text-[16px] text-sm text-right">
              تعامل مستقیم با مدرس و رفع اشکال در جلسات آنلاین
            </p>
          </div>
          <div className="relative bg-gray-100 rounded-2xl aspect-square mr-2.5 my-2.5 sm:w-32 w-20 h-20 sm:h-30">
            <Image fill alt="laptop with people" src={baseImages.lapwPeople} />
          </div>
        </div>
      </div>

      <div className="shadow-xl md:h-30 w-9/10 md:w-6/7 md:mt-0 mt-10 place-self-center rounded-2xl border border-BrightGray p-4 md:p-5 grid sm:grid-cols-2 sm:gap-2 gap-4 text-center md:flex md:flex-row">
        {/* تقویت مهارت حل مسئله */}
        <div className="h-full md:flex-1 flex sm:flex-row flex-col-reverse items-center justify-between py-2.5 px-2 min-w-0">
          <div
            style={{ direction: "rtl" }}
            className="flex-1 min-w-0 mr-2.5 md:ml-7"
          >
            <h1 className="md:text-[16px] text-[12px] font-bold whitespace-nowrap">
              تقویت مهارت حل مسئله
            </h1>
            <p className="text-[12px] whitespace-nowrap">
              حل مسئله با روش های متنوع
            </p>
          </div>

          <div className="w-12 h-12 md:w-16 md:h-16 shrink-0 mr-4 md:mr-6">
            <Image
              alt="puzzle"
              src={baseImages.puzzle}
              className="w-full h-full object-contain bg-gray-100 rounded-xl"
            />
          </div>
        </div>

        {/* تفکر منطقی */}
        <div className="h-full md:flex-1 flex sm:flex-row flex-col-reverse items-center justify-between py-2.5 px-2 min-w-0 sm:border-l border-LightGray">
          <div
            style={{ direction: "rtl" }}
            className="flex-1 min-w-0 mr-2.5 md:ml-7"
          >
            <h1 className="md:text-[16px] text-[12px] font-bold whitespace-nowrap">
              تفکر منطقی
            </h1>
            <p className="text-[12px] whitespace-nowrap">
              پرورش ذهن تحلیل‌گر و خلاق
            </p>
          </div>

          <div className="w-12 h-12 md:w-16 md:h-16 shrink-0 mr-4 md:mr-6">
            <Image
              alt="brain"
              src={baseImages.brainwHead}
              className="w-full h-full object-contain bg-gray-100 rounded-xl"
            />
          </div>
        </div>

        {/* تفکر محاسباتی */}
        <div className="h-full md:flex-1 flex sm:flex-row flex-col-reverse items-center justify-between py-2.5 px-2 min-w-0 sm:border-l border-LightGray">
          <div
            style={{ direction: "rtl" }}
            className="flex-1 min-w-0 mr-2.5 md:ml-7"
          >
            <h1 className="md:text-[16px] text-[12px] font-bold whitespace-nowrap">
              تفکر محاسباتی
            </h1>
            <p className="text-[12px] whitespace-nowrap">
              تقویت الگوریتم و استدلال منطقی
            </p>
          </div>

          <div className="w-12 h-12 md:w-16 md:h-16 shrink-0 mr-4 md:mr-6">
            <Image
              alt="brain"
              src={baseImages.brain}
              className="w-full h-full object-contain bg-gray-100 rounded-xl"
            />
          </div>
        </div>

        {/* آمادگی برای آزمون */}
        <div className="h-full md:flex-1 flex sm:flex-row flex-col-reverse items-center justify-between py-2.5 px-2 min-w-0 sm:border-l border-LightGray">
          <div
            style={{ direction: "rtl" }}
            className="flex-1 min-w-0 mr-2.5 md:ml-7"
          >
            <h1 className="md:text-[16px] text-[12px] font-bold whitespace-nowrap">
              آمادگی برای آزمون
            </h1>
            <p className="text-[12px] whitespace-nowrap">
              آشنایی با نوع و سبک سؤالات
            </p>
          </div>

          <div className="w-12 h-12 md:w-16 md:h-16 shrink-0 mr-4 md:mr-6">
            <Image
              alt="dart"
              src={baseImages.dart}
              className="w-full h-full object-contain bg-gray-100 rounded-xl"
            />
          </div>
        </div>
      </div>

      <h1 className="flex flex-row items-center text-[24px] mt-25">
        <span className="flex-1 border-b-2 border-black ml-10 md:ml-25"></span>
        <span className="mx-2">سؤالات متداول</span>
        <span className="flex-1 border-b-2 border-black mr-10 md:mr-25"></span>
      </h1>

      <FaqSection />

      {/** دکمهٔ چسبان پایین صفحه */}
      <div className="sticky bottom-20 z-40 mx-auto mt-6 w-full max-w-[1160px] sm:bottom-3.5 px-4 sm:px-0">
        <StickyRegistrationBar
          isLoggedIn={isLoggedIn}
          onOpenConference={handleOpenConferenceModal}
          onOpenSignup={() => setIsModalOpen(true)}
        />
      </div>

      <WebinarFormModal
        open={webinarFormOpen}
        onClose={() => {
          setWebinarFormOpen(false);
          window.location.hash = "";
        }}
        defaultValues={{
          firstName: profile?.firstName ?? "",
          lastName: profile?.lastName ?? "",
          phone: profile?.phoneNumber ?? "",
        }}
        onSubmit={handleWebinarSubmit}
      />

      {/** مودال موفقیت */}
      <SuccessModal
        open={registrationOpenConference}
        onClose={() => setRegistrationOpenConference(false)}
      />
    </div>
  );
};
